import { render, staticRenderFns } from "./onlinepay.vue?vue&type=template&id=54a45442&scoped=true&"
import script from "./onlinepay.vue?vue&type=script&lang=js&"
export * from "./onlinepay.vue?vue&type=script&lang=js&"
import style0 from "./onlinepay.vue?vue&type=style&index=0&id=54a45442&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a45442",
  null
  
)

export default component.exports